import MARKWE_ALERT from "assets/icons/map/marker_alert.svg";
import MARKWE_ASSIGN from "assets/icons/map/marker_assign.svg";
import MARKWE_HEALTHY from "assets/icons/map/marker_healthy.svg";
import MARKWE_WARNING from "assets/icons/map/marker_warning.svg";
import MARKWE_CRITICAL from "assets/icons/map/marker_critical.svg";
import styled from "styled-components";
import { calcRem } from "styles/theme";
import { FLEX } from "styles/flex";
import { COLORS } from "styles/colors";
import { MarkerWrapper } from "./MarkerCommonStyled";
import { AlertStatusCountType, MarkerDataType } from "../../GoogleMapContainer";
import { useCallback } from "react";

export default function SingleMarker(props: MarkerDataType): JSX.Element {
  const determineMarker = useCallback(
    ({
      warningCount,
      // assignCount,
      alertCount,
      criticalCount,
    }: AlertStatusCountType) => {
      let markerIcon = MARKWE_HEALTHY;

      if (warningCount > 0) {
        markerIcon = MARKWE_WARNING;
      }

      // if (assignCount > 0) {
      //   markerIcon = MARKWE_ASSIGN;
      // }

      if (alertCount > 0) {
        markerIcon = MARKWE_ALERT;
      }
      if (criticalCount > 0) {
        markerIcon = MARKWE_CRITICAL;
      }
      return markerIcon;
    },
    [props]
  );
  return (
    <Wrapper
      status={{
        ...props.alertStatusCount,
      }}
    >
      <span className="google-map-marker-label">{props.title}</span>
      <img
        src={determineMarker({
          ...props.alertStatusCount,
        })}
      />

      <div className="marker-circle-bg"></div>
    </Wrapper>
  );
}

const Wrapper = styled(MarkerWrapper)`
  ${FLEX.FlexCenterCenter};
  position: relative;
  width: 18px;

  .google-map-marker-label {
    pointer-events: none;
    white-space: nowrap;
    font-size: ${calcRem(15)};
    background-color: rgba(23, 31, 55, 0.8);
    padding: 4px;
    border-radius: 2px;
    color: ${COLORS.WHITE};
    position: absolute;
    bottom: 28px;
  }

  img {
    width: 100%;
  }
`;
